import { useContext } from 'react';
import { LoginContext } from '@/features/login';

export const useLoginInfo = () => {
  const context = useContext(LoginContext);
  return context;
};
